interface VideoModalProps {
  open: boolean;
  title: string;
  thumbnail: string;
  onClose: () => void;
}

export default function VideoModal({ open, title, thumbnail, onClose }: VideoModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/80 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl animate-scale-in overflow-hidden rounded-xl bg-background-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3">
          <p className="truncate text-sm font-medium text-foreground-900">{title}</p>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition hover:bg-background-100"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        <div className="relative aspect-video w-full bg-foreground-950">
          <img src={thumbnail} alt={`${title}预览`} className="h-full w-full object-cover opacity-40" />
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center px-6">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-50/15 text-background-50">
              <i className="ri-play-fill text-3xl"></i>
            </span>
            <p className="text-sm text-background-100">视频播放为前端演示，暂未接入真实视频源</p>
          </div>
        </div>
        <div className="flex items-center gap-3 px-4 py-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-information-line"></i>演示模式
          </span>
          <span>实际播出内容请以官方平台为准</span>
        </div>
      </div>
    </div>
  );
}